export function getSearchSpringSiteID(category = 'products') {
  return SS_STATE.siteIds[category]
}

export function getSearchSpringDomain(category) {
  switch (category) {
    case 'collections':
      return window.location.host + '/collections?view=ss-feed'
    case 'pages':
      return window.location.host + '/pages/faqs?view=ss-feed'
    case 'blogs':
      return window.location.host + '/blogs/news?view=ss-feed'
    case 'products':
    default:
      return window.location.href
  }
}
